module.exports = __webpack_public_path__ + "img/map2.00a557be.png";